export const config = {
  localApiUrl: process.env.REACT_APP_API_URL,
  success: "You were added to List.!",
  thankyou: "Your preference added.!",
};